<div class="gw-w-full gw-relative">
  <label class="gw-font-bold gw-text-text-primary gw-mb-[12px]">
    {{ label }}
  </label>

  <div
    *ngIf="loading"
    class="gw-border-base gw-mt-small gw-bg-background-elevation-1 gw-p-x-small gw-flex gw-items-center gw-gap-3"
  >
    <div class="gw-min-w-0 gw-w-full gw-flex-1">
      <div
        class="gw-w-full gw-h-[6px] gw-rounded-full gw-overflow-hidden gw-bg-background-neutral-2"
      >
        <div
          class="gw-h-full gw-bg-background-accent-1 gw-transition-[width] gw-duration-100"
          [style.width.%]="progress"
        ></div>
      </div>

      <p class="gw-text-[12px] gw-text-text-secondary gw-mt-2 gw-mb-0">
        Carregando imagem...
      </p>
    </div>
  </div>

  <div
    *ngIf="!loading && !previewControl?.value"
    class="gw-border-base gw-mt-small gw-bg-background-elevation-1 gw-p-x-small gw-flex gw-items-center gw-justify-between gw-gap-3"
  >
    <div class="gw-flex gw-items-center gw-gap-3 gw-w-full">
      <gatewee-icon
        icon="@tui.image"
        iconStyle="primary"
        size="38px"
      ></gatewee-icon>

      <div>
        <p class="gw-font-bold gw-text-text-primary gw-m-0">{{ title }}</p>
        <p class="gw-text-text-secondary gw-text-[12px] gw-m-0">
          {{ subtitle }}
        </p>
      </div>
    </div>

    <label
      class="gw-cursor-pointer gw-flex gw-items-center gw-border-base gw-p-2"
      title="Selecionar arquivo"
    >
      <input
        #fileInput
        type="file"
        accept="image/png,image/jpeg"
        class="gw-hidden"
        (click)="fileInput.value = ''"
        (change)="onFileChange($any($event.target).files?.[0] ?? null, fileInput)"
      />

      <gatewee-icon
        icon="@tui.upload"
        iconStyle="primary"
        size="18px"
      ></gatewee-icon>
    </label>
  </div>

  <div *ngIf="!loading && previewControl?.value" class="gw-mt-3">
    <img
      [src]="previewControl?.value"
      alt="Preview"
      class="gw-rounded-xl gw-border-base gw-w-[60px] gw-h-[60px] gw-object-cover"
    />

    <div class="gw-mt-2">
      <label
        class="gw-inline-flex gw-items-center gw-gap-2 gw-cursor-pointer gw-text-text-secondary gw-text-[12px]"
      >
        <input
          #fileInput2
          type="file"
          accept="image/png,image/jpeg"
          class="gw-hidden"
          (click)="fileInput2.value = ''"
          (change)="onFileChange($any($event.target).files?.[0] ?? null, fileInput2)"
        />
        Trocar imagem
      </label>
    </div>
  </div>

  <p
    class="gw-absolute gw-bottom-[-35px] gw-mt-2 gw-text-[12px] gw-text-status-negative"
    *ngIf="errorMsg"
  >
    {{ errorMsg }}
  </p>
</div>
